import { useState } from "react";
import ParagraphTag from "../../../reusebale/Paragraph";
import { useSelector, useDispatch } from "react-redux";
import Info from "../create-support/info";
import Credentials from "../create-support/credentials";
import Overview from "../create-support/overview";
import { ArrowLeft } from "lucide-react";
import * as DataAction from "../../../../store/actions/data/DataAction";
const CreateSupport = ({ onBack }) => {
  const steps = ["Info", "Shift", "Overview"];
  const dispatch = useDispatch();

  const SupportStaffCreateStep = useSelector(
    (state) => state.data.supportStaffCreateStep
  );

  const [formField, setFormFields] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    type: "community",
    shoftHour: 8,
    schedule: [
      { id: 1, day: "Monday", isSelected: false },
      { id: 2, day: "Tuesday", isSelected: false },
      { id: 3, day: "Wednesday", isSelected: false },
      { id: 4, day: "Thursday", isSelected: false },
      { id: 5, day: "Friday", isSelected: false },
      { id: 6, day: "Saturday", isSelected: false },
      { id: 7, day: "Sunday", isSelected: false },
    ],
  });

  return (
    <div className="h-screen w-full">
      <div className="h-[10vh] flex items-center ">
        <div
          className="bg-white size-10 rounded-full flex justify-center items-center cursor-pointer"
          onClick={onBack}
        >
          <ArrowLeft color="#FF814E" size={20} />
        </div>
        <div className="pl-4">
          <ParagraphTag
            content="Support Staff"
            classes="text-darkColor font-popinsSemiBold text-lg"
          />
          <ParagraphTag
            content="New Support Staff"
            classes="text-[#686868] font-popinsRegular text-xs"
          />
        </div>
      </div>
      <div className="h-[90vh] py-3 w-full">
        <div className="bg-white rounded-md h-full">
          <div className="w-full mx-auto h-[15%]">
            {/* Stepper */}
            <div className="relative w-[70%] mx-auto flex items-center justify-between pt-5">
              {/* Step Circles */}
              {steps?.map((step, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center w-full relative"
                >
                  {/* Circle */}
                  <div
                    onClick={() => {
                      dispatch(
                        DataAction.SupportStaffStepsChangeAction(index + 1)
                      );
                    }}
                    className={`w-8 h-8 flex items-center justify-center rounded-full border-2 ${
                      SupportStaffCreateStep === index + 1
                        ? "border-[#0381CA] bg-white text-[#0381CA]"
                        : SupportStaffCreateStep > index + 1
                        ? "border-[#0381CA] bg-[#0381CA] text-white"
                        : "border-gray-300 bg-white text-gray-500"
                    } font-popinsMedium cursor-pointer transition-all`}
                  >
                    {index + 1}
                  </div>

                  {/* Step Label */}
                  <p
                    className={`mt-1 text-xs font-popinsRegular text-[#686868] ${
                      SupportStaffCreateStep >= index + 1
                        ? "text-[#0381CA]"
                        : "text-gray-500"
                    }`}
                  >
                    {step}
                  </p>

                  {/* Line Connector */}
                  {index < steps.length - 1 && (
                    <div
                      className={`absolute top-4 left-[calc(50%+16px)] right-[calc(-50%+16px)] h-0.5 ${
                        SupportStaffCreateStep > index + 1
                          ? "bg-[#0381CA]"
                          : "bg-gray-300"
                      }`}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className="h-[85%] w-full">
            {SupportStaffCreateStep === 1 && (
              <Info
                formField={formField}
                onFirstNameChange={(value) => {
                  setFormFields({
                    ...formField,
                    firstName: value,
                  });
                }}
                onLastNameChange={(value) => {
                  setFormFields({
                    ...formField,
                    lastName: value,
                  });
                }}
                onEmailChange={(value) => {
                  setFormFields({
                    ...formField,
                    email: value,
                  });
                }}
                onPasswordChange={(value) => {
                  setFormFields({
                    ...formField,
                    password: value,
                  });
                }}
              />
            )}

            {SupportStaffCreateStep === 2 && (
              <Credentials
                formField={formField}
                onTypeChange={(value) => {
                  setFormFields({
                    ...formField,
                    type: value,
                  });
                }}
                onShiftHourChange={(value) => {
                  setFormFields({
                    ...formField,
                    shoftHour: value,
                  });
                }}
                onDaySelect={(value) => {
                  let data = [...formField.schedule];
                  for (let i = 0; i < data.length; i++) {
                    if (data[i].day === value) {
                      data[i].isSelected = !data[i].isSelected;
                    }
                  }
                  setFormFields({
                    ...formField,
                    schedule: data,
                  });
                }}
              />
            )}
            {SupportStaffCreateStep === 3 && (
              <Overview formField={formField} onCloseCreate={onBack} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateSupport;
